import { render } from "./FileReferenceComponent.vue?vue&type=template&id=49aec0c0&ts=true"
import script from "./FileReferenceComponent.vue?vue&type=script&lang=ts"
export * from "./FileReferenceComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__